import React from 'react';

import ForgotPasswordComponent from 'components/ForgotPassword';

const ForgotPassword: React.FC = () => <ForgotPasswordComponent />;

export default ForgotPassword;
